import { z } from 'zod';
/**
 * A nyelvi modell beallitasai.
 *
 * Az OpenRouteren keresztul erunk el sok szolgaltato sok modelljet, egyetlen
 * OpenAI-kompatibilis felulettel. Ket dolgot valasztunk szet szandekosan:
 *
 *  - **A KULCS kornyezeti valtozo marad.** Titok, deployhoz kotott, es nem
 *    kell futasidoben allitani. A feluleten meg maszkoltan sem jelenik meg.
 *  - **A MODELL futasidoben allithato.** Ez dontes, nem titok: uj modell
 *    jelenik meg, olcsobb lesz egy masik, vagy egyszeruen jobb magyarul - és
 *    ilyenkor nem akarunk deployolni.
 */
/** A beallitas kulcsa az `app_settings` tablaban. */
export const AI_SETTINGS_KEY = 'ai';
/**
 * `szolgaltato/modell[:valtozat]` - pl. `anthropic/claude-sonnet-4.6` vagy
 * `qwen/qwq-32b:free`. A minta nem kozmetika: egy elgepelt azonosito
 * kulonben csak az elso valodi hivasnal derulne ki.
 */
export const MODEL_ID_PATTERN = /^[\w.-]+\/[\w.:-]+$/;
export const aiSettingsSchema = z.object({
    /** Melyik modell nezi at az atiratokat. */
    model: z.string().regex(MODEL_ID_PATTERN, 'Az alak: szolgáltató/modell'),
    /**
     * Atnezesse-e a modell az elkeszult atiratokat.
     *
     * Kulon kapcsolo a modell mellett: lehet, hogy a modell be van allitva, de
     * az atiratokhoz meg nem akarjuk hasznalni (koltseg, adatvedelem).
     */
    polishTranscripts: z.boolean(),
    /**
     * Szotar a beszedfelismeronek: nevek, szakszavak, termeknevek.
     *
     * A felismero ezekre a szavakra ELFOGULT lesz - ettol talalja el a "Ricsike"
     * vagy az "ALPHAVET" alakot, amit kulonben minden hivasban maskent ir le.
     * Vesszovel vagy szokozzel elvalasztva.
     *
     * Nem varazslat: a rosszul felvett hangon ez sem segit. De a visszatero
     * neveknel ez a legolcsobb javitas.
     */
    transcribeHotwords: z.string().max(1000),
    /**
     * MELYIK MODELL ismeri fel a beszedet.
     *
     * Ugyanaz a megfontolas, mint az atnezo modellnel: ez dontes, nem titok. Egy
     * uj atirato modell megjelenesekor, vagy ha kiderul, hogy egy masik jobb
     * magyarul, ne kelljen deployolni.
     *
     * Ures ertek = a kornyezeti valtozobol jovo alapertelmezes. Igy egy
     * telepites, ahol senki nem nyult a beallitashoz, valtozatlanul mukodik.
     */
    transcribeModel: z.string().max(120),
    /**
     * MELYIK MOTOR ismerje fel a beszedet - kiadas nelkul valthato.
     *
     * Ures = a kiszolgalo beallitasa (`AVSLACK_TRANSCRIBE_PROVIDER`). Az
     * alapertek NEM elhagyhato: enelkul a mar elmentett beallitasok (amikben ez a
     * mezo meg nincs benne) nem mennenek at az ellenorzesen, es csendben
     * alapertelmezesre allnanak vissza.
     */
    transcribeProvider: z.enum(['', 'openai', 'openrouter', 'google', 'whisper']).default(''),
    /**
     * CSATORNA-OSSZEFOGLALO ("mi tortent, amig tavol voltal").
     *
     * Kulon kapcsolo, alapbol KI: a csatorna uzenetei egy KULSO szolgaltatohoz
     * mennek. Ez kimondott dontes legyen - ugyanaz a megfontolas, mint az
     * atiratok atnezesenel.
     */
    channelRecap: z.boolean().default(false),
    /** Az osszefoglalo modellje. Ures = ugyanaz, mint az atnezoe (`model`). */
    recapModel: z.string().max(120).default(''),
});
/**
 * Alapertelmezes: van modell, de az atnezes KI van kapcsolva.
 *
 * Az atirat a hivas hangjabol keszul, es az atnezes ezt a szoveget egy KULSO
 * szolgaltatohoz kuldi. Ez kimondott dontes legyen, ne alapertelmezes - a
 * felismeres maga vegig a sajat gepunkon fut.
 */
export const DEFAULT_AI_SETTINGS = {
    model: 'anthropic/claude-sonnet-4.6',
    polishTranscripts: false,
    transcribeHotwords: '',
    transcribeModel: '',
    transcribeProvider: '',
    channelRecap: false,
    recapModel: '',
};
// ─── Csatorna-osszefoglalo ────────────────────────────────────────────────────
/** Ennyi olvasatlan uzenettol kinaljuk fel az osszefoglalot. */
export const RECAP_MIN_UNREAD = 20;
/** Legfeljebb ennyi uzenetet kuldunk a modellnek (a legregebbi olvasatlantol). */
export const RECAP_MAX_MESSAGES = 200;
/** Felhasznalonkent naponta ennyi osszefoglalo - a koltseg felso korlatja. */
export const RECAP_DAILY_LIMIT = 30;
export const channelRecapSchema = z.object({
    /** 3-6 pont; mindegyik arra az uzenetre mutat, amelyikre leginkabb tamaszkodik. */
    points: z.array(z.object({ text: z.string(), messageId: z.string().nullable() })),
    /** Hany uzenetbol keszult. */
    messageCount: z.number(),
    /** Igaz, ha tobb olvasatlan volt, mint amennyit a modell megkapott. */
    truncated: z.boolean(),
});
/** A felismero motorok a feluletnek. */
export const TRANSCRIBE_PROVIDERS = [
    { id: '', label: 'Alapértelmezés (a kiszolgáló beállítása)' },
    { id: 'openrouter', label: 'OpenRouter (felhő)' },
    { id: 'google', label: 'Google Speech-to-Text (EU)' },
    { id: 'openai', label: 'OpenAI (felhő)' },
    { id: 'whisper', label: 'Helyi Whisper' },
];
/**
 * Az OpenRouter ATIRATO modelljei.
 *
 * ─── Miert kezi lista, es nem lekerdezes? ───────────────────────────────────
 *
 * Mert az OpenRouter `/api/v1/models` katalogusa a CHAT-modelleket sorolja fel
 * - az atirato modellek nincsenek benne, pedig az `/api/v1/audio/transcriptions`
 * vegpont letezik es kiszolgalja oket. (Ellenorizve: a vegpont kulcs nelkul
 * 401-et ad, nem 404-et; a katalogusban viszont egyetlen `whisper`/`transcribe`
 * nevu modell sincs.)
 *
 * A lista tehat nem lekerdezheto, csak karbantarthato. A mezo emiatt SZABADON
 * is irhato: egy uj modell nevet be lehet gepelni, nem kell kiadast varni ra.
 */
export const TRANSCRIBE_MODELS = [
    'openai/gpt-4o-transcribe',
    'openai/whisper-large-v3',
    'openai/whisper-large-v3-turbo',
    'microsoft/mai-transcribe-2',
    'x-ai/grok-stt-1.0',
    'mistralai/voxtral-mini-transcribe',
    'google/chirp-3',
    'qwen/qwen3-asr-1.7b',
    'nvidia/nemotron-3.5-asr-streaming-multilingual-0.6b',
];
export const aiSettingsInput = aiSettingsSchema.partial();
// ─── Modellkatalogus ──────────────────────────────────────────────────────────
export const openRouterModelSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    /** Ekkora szoveg fer bele. Egy hosszu megbeszeles atirata nem kicsi. */
    contextLength: z.number().nullable(),
    /** Dollar / millio token. `null`, ha a szolgaltato nem adta meg. */
    promptPrice: z.number().nullable(),
    completionPrice: z.number().nullable(),
    /**
     * Mit fogad be es mit ad ki.
     *
     * Nem reszletkerdes: az OpenRouteren beszedfelismero es kepgeneralo modellek
     * is vannak. Egy hangbemenetet KOVETELO modell a szoveges keresre 400-zal
     * valaszol - ez elo is fordult. A szoveget kezelni nem tudo modelleket ezert
     * ki sem ajanljuk.
     */
    inputModalities: z.array(z.string()),
    outputModalities: z.array(z.string()),
});
/**
 * Alkalmas-e szoveg atnezesere?
 *
 * Szoveget kell befogadnia ES szoveget adnia. A csak hangot vagy csak kepet
 * kezelo modellek a szoveges keresunkre hibaval valaszolnak - azokat meg sem
 * mutatjuk. Ha a szolgaltato nem adta meg a modalitasokat, ELFOGADJUK: inkabb
 * legyen valaszthato egy bizonytalan modell, mint hogy egy jo kimaradjon.
 */
export function isTextModel(model) {
    const accepts = model.inputModalities.length === 0 || model.inputModalities.includes('text');
    const produces = model.outputModalities.length === 0 || model.outputModalities.includes('text');
    return accepts && produces;
}
/** Ingyenes-e. Az OpenRouteren ez vagy `:free` vegzodes, vagy nulla ar. */
export function isFreeModel(model) {
    if (model.id.endsWith(':free'))
        return true;
    return model.promptPrice === 0 && model.completionPrice === 0;
}
/** `$1,20/M token` vagy `ingyenes`. A `null` azt jelenti: nem tudjuk. */
export function formatModelPrice(perToken) {
    if (perToken === null)
        return '–';
    if (perToken === 0)
        return 'ingyenes';
    const perMillion = perToken * 1_000_000;
    return `$${perMillion.toLocaleString('hu-HU', { maximumFractionDigits: 2 })}/M token`;
}
// ─── Az atirat atnezese ───────────────────────────────────────────────────────
/**
 * Ennyi szakaszt kuldunk egy keresben.
 *
 * A hosszu megbeszelesek atirata tobb ezer sor is lehet; egyben elkuldve
 * tullepne a legtobb modell keretet, es egyetlen hiba az egeszet elvinne.
 * Kotegelve egy rossz koteg csak sajat magat viszi.
 */
export const POLISH_BATCH_SIZE = 60;
//# sourceMappingURL=ai.js.map